class AbandonedCartPopup extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.cookieExpiryInDays = this.dataset.cookieExpiryDays ?? 3
    this.testMode = this.dataset.testMode

    this.checkCookie()
    this.listenToCartChanges()
  }

  setupListeners () {
    super.setupListeners()

    if (this.els.close) {
      this.handleClose = this.handleClose.bind(this)
      this.listeners.add(this.els.close.element, 'click', this.handleClose)
    }
  }

  handleClose () {
    document.cookie =
      'cart-abandoned=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax'
    this.displayPopup(false)
  }

  checkCookie () {
    if (this.isCookieOlderThan('cart-abandoned', 0) || this.testMode) {
      this.displayPopup(true)
      // reset the abandoned cart
      this.setCartAbandonedCookie(1)
    }
  }

  displayPopup (enable) {
    this.setAttribute('aria-hidden', !enable)
  }

  isCookieOlderThan (cookieName, days) {
    const cookieValue = document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${cookieName}=`))

    if (!cookieValue) return false // Cookie doesn't exist

    const value = decodeURIComponent(cookieValue.split('=')[1])

    const timestamp = new Date(value)

    if (isNaN(timestamp)) return false // Invalid date format

    const now = new Date()
    const ageInMs = now - timestamp
    const ageInDays = ageInMs / (1000 * 60 * 60 * 24)

    return ageInDays > days
  }

  listenToCartChanges () {
    if (window.BAO && window.BAO.eventBus) {
      window.BAO.eventBus.addEventListener(
        window.BAO.EVENTS.PUSH_CART.CHANGED,
        (event) => {
          // update cookie to true. We don't need the actual items as we read from the cart in liquid. This is used as an indication to display the popup.
          const itemCount =
            event.detail.state.quantity ?? event.detail.state.item_count
          this.setCartAbandonedCookie(itemCount)
        },
      )
    } else {
      console.warn('BAO event not available yet.')
    }
  }

  setCartAbandonedCookie (itemCount) {
    if (itemCount && itemCount > 0) {
      // Set cookie to the custom expiry date from settings - will be re-read upon check
      const expiryDateForCookie = new Date()
      const expiryDateForCheck = new Date()

      expiryDateForCookie.setDate(expiryDateForCookie.getDate() + Number(31))
      expiryDateForCheck.setDate(
        expiryDateForCheck.getDate() + Number(this.cookieExpiryInDays),
      )
      document.cookie = `cart-abandoned=${expiryDateForCheck}; path=/; expires=${expiryDateForCookie.toUTCString()}; SameSite=Lax`
    } else {
      // Delete the cookie by setting it to expire in the past
      document.cookie =
        'cart-abandoned=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax'
    }
  }
}

if (!customElements.get('abandoned-cart-popup')) {
  customElements.define('abandoned-cart-popup', AbandonedCartPopup)
}
